import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  ACCESS_TOKEN_KEY,
  authLoaded,
  logoutUserSuccess,
} from "features/Authentication/store/login/reducer";
import { getProfile } from "features/Authentication/services/AuthService";

export const useAuthInit = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);

    if (!token) {
      dispatch(logoutUserSuccess());
      return;
    }

    getProfile()
      .then((res) => {
        if (res.success) {
          dispatch(
            authLoaded({
              user: res.data.user,
              permissions: res.data.permissions,
            }),
          );
        } else {
          dispatch(logoutUserSuccess());
        }
      })
      .catch(() => dispatch(logoutUserSuccess()));
  }, [dispatch]);
};
